import * as React from 'react';
import { navigate } from 'gatsby-link';
import { Box, Flex, Text } from '@chakra-ui/react';
import queryString from 'query-string';
import { IoIosArrowForward } from 'react-icons/io';

import filterTypes from '../../utitlities/filterTypes';
import { noSubcategory }from '../../utitlities/productsFilter';

import ProductsList from '../../components/ProductsList';
import FiltersBar from '../../components/FiltersBar';
import LinkWrapper from '../../components/LinkWrapper';

import useWindowSize from '../../utitlities/useWindowSize';

/* IMPORT APP CONTEXT */
import { AppContext } from '../../context';

const isBrowser = typeof window !== "undefined";

function ProductsListFilter(props) {
  const { refToUse, hasSubcategories, topBarFilter, isCollectionPage, currentPage, productsToFilter, allStates, productsBaseRoute } = props;
  const appContext = React.useContext(AppContext);

  /* FILTER FROM shop-all PAGE */
  const queryFilter = props.filter;
  const [slashQuery, setSlashQuery] = React.useState({});

  /******************************************************
   * FILTER BAR OPTIONS 
  ******************************************************/
  const defaultFilterOptions = [
    {title: 'product type', name:'productType'},
    {title: 'state availability', name:'state'},
    {title: 'class and ratios', name:'classAndRatios'},
    {title: 'effect', name:'effect'},
    {title: 'store', name:'storeType'},
  ];

  /* STATE AVAILABILITY */
  const [isHeroShowing, setIsHeroShowing] = React.useState(true);

  React.useEffect(() => {
    /* UPDATE TOPBAR FILTER SCROLL POSITION */
    if (isBrowser) {
      const topBar = document.getElementById('top-bar');

      const topBarChildren = topBar.childNodes;
      let leftScroll = 0;
      
      const pageIndex = props.location.pathname === topBarFilter[0].link ? 0 : topBarFilter.findIndex(item => item.link === props.location.pathname);
      
      for (let i = 0; i < pageIndex; i++) {
        leftScroll += (topBarChildren[i].clientWidth * (pageIndex === 1 ? 0.25 : 0.85));
      }
  
      // console.log('leftScroll: ', leftScroll);
      topBar.scrollLeft += leftScroll;
    }

    /* SET CURRENT SUBCATEGORY */
    let subcategory = undefined;

    if (props.slashQuery && typeof props.slashQuery !== 'string') {
      subcategory = props.slashQuery[1];
    }

    /* INTERSECTION OBSERVER FOR THE HERO SECTION */
    if (isBrowser) {
      const heroSection = document.getElementById('hero-section');
      const observer = new IntersectionObserver((entries) => {
        setIsHeroShowing(entries[0].isIntersecting);
      });

      observer.observe(heroSection);
    }

    appContext.actions.updateQueryFilters(queryFilter)
  }, []);

  /* FILTER OPTIONS INITIAL STATE */
  const INITIAL_FILTERS = {
    [filterTypes.CATEGORY]: [],
    [filterTypes.SUBCATEGORY]: [],
    [filterTypes.STATE]: [],
    [filterTypes.LINEAGE]: [],
    [filterTypes.EFFECT]: [],
    [filterTypes.STORETYPE]: [],
  };

  /* FILTER OBJECT STATE */
  const [objFilters, setObjFilters] = React.useState({...INITIAL_FILTERS});

  /* CHECK WHEN queryFilter CHANGES AND JUST UPDATE FILTERS BAR STATE */
  React.useEffect(() => {
    if (props.slashQuery) {
      /* WHEN FILTERING IN CATEGORIES PAGES */
      const objArr = {...objFilters};
      
      /* CHECK IF IS A SHOP/CATEGORY PAGE OR A SHOP/CATEGORY/SUBCATEGORY PAGE */
      if (typeof props.slashQuery === 'string') {
        /* SHOP/CATEGORY PAGE */
        /* ADD CATEGORY TO objFilters IN CATEGORY PAGES */
        if (!objArr[filterTypes.CATEGORY].includes(props.slashQuery)) {
          objArr[filterTypes.CATEGORY].push(props.slashQuery);
        }
      } else {
        /* SHOP/CATEGORY/SUBCATEGORY PAGE */
        /* ADD CATEGORY TO objFilters IN CATEGORY/SUBCATEGORY PAGES */
        if (!objArr[filterTypes.CATEGORY].includes(props.slashQuery[0])) {
          objArr[filterTypes.CATEGORY].push(props.slashQuery[0]);
        }

        /* ADD SUBCATEGORY TO objFilters IN CATEGORY/SUBCATEGORY PAGES */
        if (!objArr[filterTypes.SUBCATEGORY].includes(props.slashQuery[1])) {
          objArr[filterTypes.SUBCATEGORY].push(props.slashQuery[1]);
        }
      }
      
      /* ADD qsObject TO objFilters IN CATEGORY PAGES */
      const qsObject = queryString.parse(props.location.search, { arrayFormat: 'comma' });
      
      Object.keys(qsObject).map((item, indx) => {
        
        if (typeof qsObject[item] === 'string') {
          objArr[item] = [qsObject[item]];
        } else {
          objArr[item] = qsObject[item];
        }
      });

      const slashCopy = {};

      Object.keys(objArr).map((item, indx) => {
        if (objArr[item].length > 0) {
          slashCopy[item] = objArr[item];
        }
      });
      
      /* UPDATE FILTERS BAR STATE */
      setObjFilters(objArr);

      /* UPDATE SLASHQUERY FILTER */
      setSlashQuery(slashCopy);

    } else {
      /* WHEN FILTERING IN SHOP ALL PAGE */
      const objArr = {...objFilters};
      
      // console.log('queryFilter UPDATED: ', queryFilter);
  
      if (Object.keys(queryFilter).length === 0) {
        // console.log('queryFilter is empty');
        setObjFilters({...INITIAL_FILTERS});
  
      } else {
  
        Object.keys(objFilters).map((key) => {
          if (key === filterTypes.SUBCATEGORY) {
            objArr[key] = queryFilter[key] ? queryFilter[key].filter(item => item !== noSubcategory) : [];
          } else {
            objArr[key] = queryFilter[key] ? queryFilter[key] : [];
          }
        });
  
        // console.log('FINAL FINAL FILTER: ', objArr);
  
        setObjFilters(objArr);
  
      }
    }
  }, [queryFilter]);

  /* UPDATE FILTER STATE WHEN AN OPTION IS SELECTED AND CALL THE FUNTION TO UPDATE THE URL */
  const onCheckedStateChanged = (filter) => {
    /* COPY objFilters STATE */
    const objArr = {...objFilters};
    
    /* PUSH OPTION SELECTED VALUE TO THE objFilters ARRAY */
    if (!objArr[filter.filterType].includes(filter.value)) {
      objArr[filter.filterType].push(filter.value);
    } else {
      const valueIndx = objArr[filter.filterType].indexOf(filter.value);
      const removed = objArr[filter.filterType].splice(valueIndx, 1);
    }

    /* UPDATE objFilters STATE */
    setObjFilters(objArr);

    /* UPDATE URL */
    updateURL();
    appContext.actions.updateQueryFilters(objFilters)
  }

  /* UPDATE URL WHEN AN OPTION IS SELECTED TO FILTER THE PRODUCTS LIST */
  const updateURL = () => {
    /* WHEN FILTERING IN CATEGORIES PAGES */
    if (props.slashQuery) {
      let queryStr = '';

      if (typeof props.slashQuery === 'string') {
        /* WHEN FILTERING IN CATEGORY PAGE - PREVENT ADDING CATEGORY TO URL */
        const {category, ...noCatQuery} = objFilters;
        queryStr = queryString.stringify(noCatQuery, { arrayFormat: 'comma' });
        
      } else {
        /* WHEN FILTERING IN CATEGORY/SUBCATEGORY PAGES - PREVENT ADDING CATEGORY AND SUBCATEGORY TO URL */
        const {category, subcategory, ...noCatSubcatQuery} = objFilters;
        queryStr = queryString.stringify(noCatSubcatQuery, { arrayFormat: 'comma' });

      }

      /* NAVIGATE TO URL WITH QUERY PARAMS */
      navigate(`?${queryStr}`);

    } else {
      /* WHEN FILTERING IN SHOP ALL PAGE */
      const queryStr = queryString.stringify(objFilters, { arrayFormat: 'comma' });
      navigate(`?${queryStr}`);
    }
  }

  /**********************************************
  * FUNCTIONS FOR MOBILE FILTER BAR 
  **********************************************/
  const onMobileCheckStateChange= (filter) => {
    /* COPY objFilters STATE */
    const objArr = {...objFilters};

    /* PUSH OPTION SELECTED VALUE TO THE objFilters ARRAY */
    if (!objArr[filter.filterType].includes(filter.value)) {
      objArr[filter.filterType].push(filter.value);
    } else {
      const valueIndx = objArr[filter.filterType].indexOf(filter.value);
      const removed = objArr[filter.filterType].splice(valueIndx, 1);
    }

    /* UPDATE objFilters STATE */
    setObjFilters(objArr);
  };

  const clearFilters = () => {
    setObjFilters({...INITIAL_FILTERS});

    const queryStr = queryString.stringify(INITIAL_FILTERS, { arrayFormat: 'comma' });
    navigate(`?${queryStr}`);
  };

  /**********************************************
  * TOP BAR FILTERS SCROLL
  **********************************************/
  const [showLeftArrow, setShowLeftArrow] = React.useState(false);
  const [showRightArrow, setShowRightArrow] = React.useState(true);

  return (
    <Box
      maxW={{base:'100%', xl:'1200px'}}
      h="auto"
      m="auto"
      // mt={{base:'60px', md:'100px', lg:'120px', xl:'150px'}}
      mb={{base:'100px'}}
      zIndex="1"
    >
      <Box 
        ref={appContext.productsListTopRef}
        w="100%"
        h="1px"
        bgColor="transparent"
      />

      {/* TOP FILTER BAR */}
      <Box
        w={{base:'90%', md:'84%', xl:'100%'}}
        h="auto"
        m="auto"
        display={{base:'block', md:'none'}}
        gridTemplateColumns={{
          md:'30% 70%',
          lg:'25% 75%',
          xl:'25% 75%',
        }}
        ref={refToUse}
        position={{base:'sticky', md:'sticky'}}
        top={{base:'23px', md:'23px'}}
        zIndex="3"
        // overflowX="clip"
        // border="1px"
      >
        <Box />

        <Box 
          h="auto"
          bgColor="white"
          boxShadow={!isHeroShowing ? {base: '0px 5px 10px -10px #131029'} : null}
          pb={{
            base: '5px',
            md: !isHeroShowing ? '5px' : null
          }}
          position="relative"
          // border="1px"
        >
          <Box 
            w="100%"
            h="26px"
            bgColor="white"
            position="absolute"
            top="-24px"
          />

          {topBarFilter && (
            <TopBarFilter 
              topBarFilter={topBarFilter} 
              pathname={props.location.pathname} 
              setShowLeftArrow={setShowLeftArrow}
              setShowRightArrow={setShowRightArrow}
              Option={(data) => <TopBarOption option={data.option} pathname={data.pathname} mr={data.mr} />} 
              elementID={'top-bar'}
            />
          )}

          {/* RIGHT ARROW ICON */}
          <Box
            display={showRightArrow ? 'block' : 'none'}
            w={{base:'16px', md:'12px', lg:'12px'}}
            h={{base:'16px', md:'12px', lg:'12px'}}
            position="absolute"
            top={{base:'28%', md:'28%', lg:'29%', xl:'14px'}}
            right={{base:'-16px', md:'-14px', lg:'-15px'}}
            onClick={() => {
              if (!isBrowser) return 

              // MOVE RIGHT
              const topBar = document.getElementById('top-bar');
              topBar.scrollLeft += 100;
            }}
          >
            <IoIosArrowForward style={{color:'#272158', width:'100%', height:'100%'}}/>
          </Box>

          {/* LEFT ARROW ICON */}
          <Box
            display={showLeftArrow ? 'block' : 'none'}
            w={{base:'16px', md:'12px', lg:'12px'}}
            h={{base:'16px', md:'12px', lg:'12px'}}
            position="absolute"
            top={{base:'28%', md:'28%', lg:'29%', xl:'14px'}}
            transform={{base:'rotate(180deg)'}}
            left={{base:'-16px', md:'-14px', lg:'-15px'}}
            onClick={() => {
              if (!isBrowser) return 

              // MOVE LEFT
              const topBar = document.getElementById('top-bar');
              topBar.scrollLeft -= 100;
            }}
          >
            <IoIosArrowForward style={{color:'#272158', width:'100%', height:'100%'}}/>
          </Box>
        </Box> 
      </Box>

      {/* CONTENT */}
      <Box
        w={{base:'90%', md:'84%', xl:'100%'}}
        h="100%"
        m="auto"
        mt={{md:'1.5vw', xl:'20px'}}
        display={{base:'block', md:'grid'}}
        gridTemplateColumns={{
          md:'28% 2% 70%',
          lg:'22% 3% 75%',
          xl:'21% 4% 75%',
        }}
        position="relative"
        // border="1px"
      >
        {/* DESKTOP FILTERS BAR */}
        <Box 
          display={{base:'none', md:'block'}}
        >
          <Box
            className="sticky"
            top="65px"
          >
            <FiltersBar 
              filterItems={defaultFilterOptions}
              objFilters={objFilters}
              onCheckedStateChanged={onCheckedStateChanged}
              clearFilters={clearFilters}
              refToUse={refToUse}
              slashQuery={props.slashQuery}
              statesAvailable={allStates}
              productsToFilter={productsToFilter}
              isMobile={false}
              topBarFilter={topBarFilter}
              pathname={props.location.pathname}
              location={props.location}
            />
          </Box>
        </Box>

        <Box 
          display={{base:'none', md:'none'}}
          h="30px"
          className="sticky"
          top="73px"
          zIndex="2"
          bgColor="white"
        />

        {/* MOBILE FILTERS BAR */}
        <Box 
          display={{base:'block', md:'none'}}
          // className="sticky"
          // top="100px"
          zIndex="2"
          bgColor="white"
          boxShadow={{
            base:'0px 5px 10px -10px #131029',
          }}
        >
          <FiltersBar 
            filterItems={defaultFilterOptions.slice(1)}
            objFilters={objFilters}
            onCheckedStateChanged={onMobileCheckStateChange}
            showFilterResults={() => updateURL()}
            clearFilters={clearFilters}
            refToUse={refToUse}
            slashQuery={props.slashQuery}
            statesAvailable={allStates}
            productsToFilter={productsToFilter}
            isMobile={true}
            topBarFilter={topBarFilter}
            pathname={props.location.pathname}
            location={props.location}
          />
        </Box>
        
        {/*SPACE */}
        <Box bgColor="transparent" />

        {/* PRODUCTS LIST */}
        <Box 
          mt={{base:'40px',  md:'0' }}
        >
          {/* SEARCH RESULTS */}
          <ProductsList
            // USE slashQuery IN CATEGORY AND SUBCATEGORY PAGES, USE queryFilter IN SHOP-ALL PAGE 
            filter={props.slashQuery ? slashQuery : queryFilter}
            isCollectionPage={isCollectionPage}
            productsToFilter={productsToFilter}
            productsBaseRoute={productsBaseRoute}
            location={props.location}
          />
        </Box>
      </Box>
      
    </Box>
  );
}

const TopBarFilter = (props) => {
  const { topBarFilter, pathname, setShowLeftArrow, setShowRightArrow, Option, elementID } = props;
  const windowSize = useWindowSize();
  const topBarRef = React.useRef(null);

  const topBar = isBrowser ? document.getElementById(elementID) : null;

  const checkIfOverflows = (el) => {
    let isOverflowing = el.clientWidth < el.scrollWidth;
    // console.log('checkIfOverflows');
    return isOverflowing;
  }

  /* CHECK IF CONTENT IS OVERFLOWING */
  React.useEffect(() => {
    isBrowser ? setShowRightArrow(topBar ? checkIfOverflows(topBar) : false) : null;
  }, [windowSize]);

  return (
    <Flex
      className="hide-scrollbar hide-scrollbar-firefox"
      id={elementID}
      ref={topBarRef}
      maxW={{base:'100%'}}
      overflowX={{base:'auto'}}
      position="relative"
      onScroll={() => setShowLeftArrow(topBar.scrollLeft > 0)}
    >
      {topBarFilter.map((option, indx) => {
        
        return (
          <Option 
            key={indx} 
            option={option} 
            pathname={pathname} 
            mr={(topBarFilter.length - 1) === indx ? {base:'0'} : null} 
          />
        );
      })}
    </Flex>
  );
};

const TopBarOption = ({ option, pathname, mr }) => {
  
  return (
    <LinkWrapper href={option.link}>
      <Box
        w="max-content"
        bgColor={pathname === option.link ? 'grayBG' : 'transparent'}
        py={{base:'5px', md:'5px'}}
        px={{base:'8px', md:'8px'}}
        _hover={{bgColor:pathname === option.link ? 'grayBG' : 'gray.300'}}
        mr={mr || {base:'12.5px', md:'1.7vw', lg:'2.43vw', xl:'35px'}}
      >
        <Text
          color="primaryDarker"
          fontSize={{base:'14px', md:'12px', lg:'12px'}}
          fontWeight="800"
          letterSpacing="2px"
          lineHeight="2.5"
          textTransform="uppercase"
        >
          {option.text}
        </Text>
      </Box>
    </LinkWrapper>
  );
}; 

export { ProductsListFilter, TopBarFilter };
